import FilterRequests from "./FilterRequestsClass";
import Utils from "../UtilsClass";

export default class FilterSearch extends FilterRequests{
    constructor (argFilter) {
       super();
       this.containter = $(argFilter.container);
       this.filterUrl = argFilter.filterUrl;
       this.fastFiltersCl = argFilter.fastFiltersCl;
       this.rangeFiltersCl = argFilter.rangeFiltersCl;
       this.filtersCl = argFilter.filtersCl;
       this.optionsFiltersCl = argFilter.optionsFiltersCl;
       this.categoryFiltersCl = argFilter.categoryFiltersCl;
       this.changeViewCl = argFilter.changeViewCl;
       this.params = argFilter.params;
       this.sortFlag = false;
       this.loadMore = false;

       this.actions();
    }

    /**
     *
     * @param params
     */
    setParams (params) {
        this.params = $.extend(this.params, params);
        this.refresh();
    };

    /**
     *
     * @param name
     * @returns {null|*}
     */
    getParam (name) {
        if (name in this.params) {
            return this.params[name];
        }
        return null;
    };

    refresh () {
        let self = this;

        self.preloader(true);
        let req = this.post(this.filterUrl, this.params);

        req.then(function (resp) {

            $.each(resp.replace, function (name, code) {
                $('#xhr-' + name).html(code);
            });
            $.each(resp.append, function (name, code) {
                $('#xhr-' + name).append(code);
            });
            history.replaceState({}, null, resp.url);

            $(".dotdotdot").dotdotdot({
                height: 60,
                watch: 'window'
            });

            //GO TOP IF CHANGE FILTER|PAGINATE
            if(resp.append.length === 0) {
                self.scrollToTop();
            }

            //Initial fixed filter
            if(self.loadMore) {
                self.fixedSidebar.updateSticky();
                self.loadMore = false;
            } else {
                self.fixedFilter();
            }

        });
        req.always(function () {
            self.preloader(false, self.params.resetAll);
        });
    }

    /**
     * All actions
     */
    actions() {
        let self = this;

        // Sorting
        this.containter.on('click', this.fastFiltersCl, function() {
            let f = $(this).attr('data-f');

            if (!f) {
                return;
            }
            let params = self.decode(f);
            params['page'] = 1;
            params['start'] = 1;
            self.sortFlag = true;
            self.setParams(params);
        });

        //Filters
        this.containter.on('change', this.filtersCl, function() {
            let name = $(this).attr('name');
            if (!name) {
                return;
            }
            let $selected = self.containter.find(self.filtersCl + '[name="'+name+'"]:checked');

            let isArray = false;
            if (name.substr(-2) === '[]') {
                isArray = true;
                name = name.substr(0, name.length - 2);
            }

            let obj = {};
            if ($selected.length) {
                // добавить фильтр
                $selected.each(function () {
                    let value = $(this).attr('value');
                    if (isArray) {
                        if (!obj.hasOwnProperty(name)) {
                            obj[name] = [];
                        }
                        obj[name].push(value);
                    } else {
                        obj[name] = value;
                    }
                });
            } else {
                // сброс фильтра
                obj[name] = isArray ? [] : null;
            }

            obj['page'] = 1;
            obj['start'] = 1;

            self.setParams(obj);
        });

        //Price
        //TODO: надалі може бути не лише ціна
        this.containter.on('click', this.rangeFiltersCl, function() {
            // validate
            let from = $(this).closest('.value_ranges').find('input.from'),
                to = $(this).closest('.value_ranges').find('input.to');

            from.removeClass('error');
            to.removeClass('error');

            let priceFrom = Number(from.val()),
                priceTo = Number(to.val());

            if (isNaN(priceFrom) || isNaN(priceTo) || priceFrom > priceTo) {
                from.addClass('error');
                to.addClass('error');
                return;
            }

            let priceFromDefault = Number(from.attr('min')),
                priceToDefault = Number(to.attr('max')),
                priceParam = priceFrom + '-' + priceTo;

            if (Math.abs(priceFrom - priceFromDefault) < 0.001 && Math.abs(priceTo - priceToDefault) < 0.001) {
                priceParam = null;
            }

            //TODO:
            self.setParams({
                prices: [],
                price: priceParam,
                page: 1,
                start: 1
            });
        });

        //Options
        this.containter.on('change', this.optionsFiltersCl, function() {
            let obj = {};
            obj['options'] = [];
            $(this).closest('.form_style').find('input[type=checkbox]:checked').each(function () {
                obj['options'].push($(this).attr('name'));
            });

            obj['page'] = 1;
            obj['start'] = 1;

            self.setParams(obj);
        });

        //Categories
        this.containter.on('change', this.categoryFiltersCl, function() {
            console.log('Change category');
            let obj = {};
            obj['categories'] = [];
            $(this).closest('.form_style').find('input[type=checkbox]:checked').each(function () {
                obj['categories'].push($(this).val());
            });

            obj['page'] = 1;
            obj['start'] = 1;

            self.setParams(obj);
        });

        //Load more
        this.containter.on('click', '.load_more_btn', function(e) {
            e.preventDefault();

            let page = parseInt(self.getParam('page'));
            self.sortFlag = true;
            self.setParams({
                page: page + 1
            });
        });

        //Pagination
        this.containter.on('click', '.pagination li[data-p]', function(e) {
            e.preventDefault();

            let page = $(this).attr('data-p');
            self.sortFlag = true;
            self.setParams({
                start: page,
                page: page
            });
        });

        //Change view
        this.containter.on('click', this.changeViewCl, function() {
            let f = $(this).attr('data-f');
            if (!f) {
                return;
            }
            let params = self.decode(f);
            params['page'] = 1;
            params['start'] = 1;

            self.setParams(params);
        });

        //Reset all
        this.containter.on('click', '.reset-all-filters', function(e) {
            e.preventDefault();

            //Range
            $(self.rangeFiltersCl).each(function () {
                let $rb = $(this).closest('.value_ranges');
                console.log($rb.find('input.from'));
                $rb.find('input.from').val($rb.find('input.from').attr('min'));
                $rb.find('input.to').val($rb.find('input.to').attr('max'));
            });

            //Сheckbox
            $(self.filtersCl).each(function () {
                $(this).prop('checked', false);
            });

            self.setParams({
                prices: [],
                price: null,
                brands: [],
                values: [],
                options: [],
                page: 1,
                start: 1,
                resetAll: true
            });
        });
    }
}
